<div class="p-fluid">
    <form [formGroup]="orderTypeForm" >
      <div class="field">
        <label for="type_name">Order Type Name</label>
        <input pInputText id="type_name" formControlName="type_name" />
      </div>
  
      <div class="field">
        <label>Order Size</label>
        <p-dropdown
          [options]="['A4', 'A5']"
          formControlName="order_size"
          placeholder="Select size"
        ></p-dropdown>
      </div>

  
      <div formArrayName="bulk_order_options">
        <div
          *ngFor="let option of bulk_order_options.controls; let i = index"
          [formGroupName]="i"
          class="field"
        >
        <label>Option Name</label>
          <input
            pInputText
            formControlName="option_name"
            placeholder="Option Name"
            class="mb-2"
          />
          
          <button
            pButton
            type="button"
            icon="pi pi-trash"
            (click)="removeOption(i)"
            class="p-button-danger p-button-sm"
          ></button>
        </div>
  
        <button
          pButton
          label="Add Option"
          icon="pi pi-plus"
          type="button"
          (click)="addOption()"
        ></button>
      </div>
    </form>
  
    <div class="p-dialog-footer mt-4">
      <button pButton label="Cancel" class="p-button-secondary" (click)="cancel()"></button>
      <button pButton label="Save" (click)="submit()" [disabled]="orderTypeForm.invalid"></button>
    </div>
  </div>
  